(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/reduce-free-bets.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/reduce-free-bets.js');
"use strict";

var _parseInt, _styles, _parseInt2, _styles2, _parseInt3, _styles3;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _svs$components$tipse = svs.components.tipsen.engine.actions,
  setSignDistribution = _svs$components$tipse.setSignDistribution,
  toggleAlternative = _svs$components$tipse.toggleAlternative;
const _svs$components$tipse2 = svs.components.tipsen.engine.selectors.couponSelectors,
  selectEventSelections = _svs$components$tipse2.selectEventSelections,
  selectSystemType = _svs$components$tipse2.selectSystemType,
  selectSignDistribution = _svs$components$tipse2.selectSignDistribution;
const useBranding = svs.components.tipsen.hooks.useBranding;
const _React = React,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback,
  useRef = _React.useRef,
  useState = _React.useState;
const _svs$ui = svs.ui,
  ReactIcon = _svs$ui.ReactIcon,
  ReactButtonBet = _svs$ui.ReactButtonBet;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const tipsenEl = document.querySelector('#tipsen');
let styles;
if (tipsenEl) {
  styles = window.getComputedStyle(tipsenEl);
}
const BUTTON_BET_MARGIN_SELECTED = (_parseInt = parseInt((_styles = styles) === null || _styles === void 0 ? void 0 : _styles.getPropertyValue('--BUTTON_BET_MARGIN_SELECTED'), 10)) !== null && _parseInt !== void 0 ? _parseInt : 0;
const HALF_BUTTON_BET_MARGIN_SELECTED = BUTTON_BET_MARGIN_SELECTED / 2;
const CONTROLLER_WIDTH = (_parseInt2 = parseInt((_styles2 = styles) === null || _styles2 === void 0 ? void 0 : _styles2.getPropertyValue('--CONTROLLER_WIDTH'), 10)) !== null && _parseInt2 !== void 0 ? _parseInt2 : 0;
const HALF_CONTROLLER_WIDTH = CONTROLLER_WIDTH / 2;
const MIN_BUTTON_SIZE = (_parseInt3 = parseInt((_styles3 = styles) === null || _styles3 === void 0 ? void 0 : _styles3.getPropertyValue('--MIN_BUTTON_SIZE'), 10)) !== null && _parseInt3 !== void 0 ? _parseInt3 : 0;
const MIN_PERCENTAGE = 10;
const clampPercentages = (percent, maxPercent) => Math.min(Math.max(percent, MIN_PERCENTAGE), maxPercent);
const SelectedControl = {
  None: 0,
  Left: 1,
  Right: 2
};
const Index = {
  Home: 0,
  Draw: 1,
  Away: 2
};
const preventDefault = e => {
  e.preventDefault();
};
const ReduceButtonBet = _ref => {
  let branding = _ref.branding,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    isDisabled = _ref.isDisabled,
    label = _ref.label,
    onClick = _ref.onClick,
    refFunc = _ref.refFunc,
    selected = _ref.selected,
    index = _ref.index,
    ariaLabel = _ref.ariaLabel;
  const buttonOnClick = useCallback(() => {
    onClick(index);
  }, [onClick, index]);
  return React.createElement(ReactButtonBet, {
    "aria-label": ariaLabel,
    branding: branding,
    className: className,
    "data-testid": dataTestId,
    disabled: isDisabled,
    label: label,
    onClick: buttonOnClick,
    ref: refFunc,
    selected: selected,
    type: "button"
  });
};
const ReduceFreeBets = _ref2 => {
  let couponId = _ref2.couponId,
    board = _ref2.board,
    event = _ref2.event,
    outcomeLabels = _ref2.outcomeLabels,
    isDisabled = _ref2.isDisabled;
  const dispatch = useDispatch();
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const selections = useSelector(state => selectEventSelections(state, couponId, board, event));
  const distribution = useSelector(state => selectSignDistribution(state, couponId, board, event));
  const _useState = useState(SelectedControl.None),
    _useState2 = _slicedToArray(_useState, 2),
    selectedControl = _useState2[0],
    setSelectedControl = _useState2[1];
  const _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    originalPosition = _useState4[0],
    setOriginalPosition = _useState4[1];
  const isControlLeftVisible = !isDisabled && selections[Index.Home] && (selections[Index.Draw] || selections[Index.Away]);
  const isControlRightVisible = !isDisabled && selections[Index.Away] && (selections[Index.Draw] || selections[Index.Home]);
  const reduceContainer = useRef();
  const reduceContainerWidth = useRef(0);
  const controllers = useRef({
    leftController: undefined,
    rightController: undefined
  });
  const betButtons = useRef([undefined, undefined, undefined]);
  const distributionToFraction = useCallback(indexDistribution => indexDistribution / distribution.reduce((a, b) => a + b, 0), [distribution]);
  const distributionToPercentage = useCallback(indexDistribution => distributionToFraction(indexDistribution) * 100, [distributionToFraction]);
  const numSelectedButtons = selections.filter(selected => selected).length;
  const allButtonsSelected = numSelectedButtons === selections.length;
  const homePercentage = distributionToPercentage(distribution[Index.Home]);
  const drawPercentage = distributionToPercentage(distribution[Index.Draw]);
  const awayPercentage = distributionToPercentage(distribution[Index.Away]);
  const newHomePercentage = useRef(homePercentage);
  const newDrawPercentage = useRef(drawPercentage);
  const newAwayPercentage = useRef(awayPercentage);
  const roundOfAThird = useCallback(() => {
    if (distribution[Index.Home] === distribution[Index.Draw] && distribution[Index.Draw] === distribution[Index.Away] && newHomePercentage.current === newAwayPercentage.current) {
      newHomePercentage.current = 34; 
      newDrawPercentage.current = 33;
      newAwayPercentage.current = 33;
    }
  }, [distribution]);
  useEffect(() => {
    newHomePercentage.current = distributionToPercentage(distribution[Index.Home]);
    newDrawPercentage.current = distributionToPercentage(distribution[Index.Draw]);
    newAwayPercentage.current = distributionToPercentage(distribution[Index.Away]);
    roundOfAThird();
  }, [distribution, roundOfAThird, distributionToPercentage]);
  const calculateWidthWithoutMargin = useCallback(width => {
    var _parseInt4, _styles4;
    const BUTTON_BET_MARGIN = (_parseInt4 = parseInt((_styles4 = styles) === null || _styles4 === void 0 ? void 0 : _styles4.getPropertyValue('--BUTTON_BET_MARGIN'), 10)) !== null && _parseInt4 !== void 0 ? _parseInt4 : 0;
    if (allButtonsSelected || selections[Index.Home] && selections[Index.Away]) {
      return width - 2 * BUTTON_BET_MARGIN_SELECTED;
    } else if (selections[Index.Home] && selections[Index.Draw] || selections[Index.Away] && selections[Index.Draw]) {
      return width - (BUTTON_BET_MARGIN_SELECTED + BUTTON_BET_MARGIN);
    }
    return width - 2 * BUTTON_BET_MARGIN;
  }, [allButtonsSelected, selections]);
  const getBetButtonWidth = useCallback(() => {
    const buttonSize = Math.round(calculateWidthWithoutMargin(reduceContainerWidth.current) * (MIN_PERCENTAGE / 100));
    return buttonSize < MIN_BUTTON_SIZE ? MIN_BUTTON_SIZE : buttonSize;
  }, [calculateWidthWithoutMargin]);
  const getAvailableReduceContainerWidth = useCallback(() => {
    let pixelsToSubtract = 0;
    selections.forEach(selected => {
      if (!selected) {
        pixelsToSubtract += getBetButtonWidth();
      }
    });
    const reducerContainerWidth = calculateWidthWithoutMargin(reduceContainerWidth.current);
    return reducerContainerWidth - pixelsToSubtract;
  }, [calculateWidthWithoutMargin, getBetButtonWidth, selections]);
  const getTotalAvailableWidthFraction = useCallback(() => getAvailableReduceContainerWidth() / 100, [getAvailableReduceContainerWidth]);
  const getButtonSizes = useCallback(() => {
    let availableWidth = reduceContainerWidth.current;
    if (numSelectedButtons === 0) {
      const width = availableWidth / selections.length;
      return {
        homeWidth: width,
        drawWidth: width,
        awayWidth: width
      };
    }
    const percentages = [{
      index: Index.Home,
      percent: newHomePercentage.current
    }, {
      index: Index.Draw,
      percent: newDrawPercentage.current
    }, {
      index: Index.Away,
      percent: newAwayPercentage.current
    }];
    const totalAvailableWidthFraction = getTotalAvailableWidthFraction();
    const newWidths = [];
    const weightedPercentages = percentages.sort((a, b) => a.percent - b.percent);
    weightedPercentages.forEach(el => {
      let width;
      if (selections[el.index]) {
        const percentWidth = el.percent * totalAvailableWidthFraction;
        width = percentWidth < MIN_BUTTON_SIZE ? MIN_BUTTON_SIZE : percentWidth;
      } else {
        width = getBetButtonWidth();
      }
      if (availableWidth < width) {
        width = availableWidth;
      }
      availableWidth -= width;
      newWidths[el.index] = width;
    });
    return {
      homeWidth: newWidths[Index.Home],
      drawWidth: newWidths[Index.Draw],
      awayWidth: newWidths[Index.Away]
    };
  }, [getBetButtonWidth, getTotalAvailableWidthFraction, numSelectedButtons, selections]);
  const getControllerPositions = useCallback((homeWidth, awayWidth) => {
    const leftControlPosition = homeWidth + HALF_BUTTON_BET_MARGIN_SELECTED;
    const rightControlPosition = reduceContainerWidth.current - (awayWidth + HALF_BUTTON_BET_MARGIN_SELECTED);
    return {
      leftControlPosition: leftControlPosition - HALF_CONTROLLER_WIDTH,
      rightControlPosition: rightControlPosition - HALF_CONTROLLER_WIDTH
    };
  }, []);
  const updateInterface = useCallback(() => {
    const _getButtonSizes = getButtonSizes(),
      homeWidth = _getButtonSizes.homeWidth,
      drawWidth = _getButtonSizes.drawWidth,
      awayWidth = _getButtonSizes.awayWidth;
    const _getControllerPositio = getControllerPositions(homeWidth, awayWidth),
      leftControlPosition = _getControllerPositio.leftControlPosition,
      rightControlPosition = _getControllerPositio.rightControlPosition;
    const homeBetButton = betButtons.current[Index.Home];
    const drawBetButton = betButtons.current[Index.Draw];
    const awayBetButton = betButtons.current[Index.Away];
    const windowAnimation = (homeWidth, drawWidth, awayWidth, leftControlPosition, rightControlPosition) => {
      betButtons.current[Index.Home].style.width = "".concat(Math.round(homeWidth), "px");
      betButtons.current[Index.Draw].style.width = "".concat(Math.round(drawWidth), "px");
      betButtons.current[Index.Away].style.width = "".concat(Math.round(awayWidth), "px");
      if (controllers.current.leftController) {
        controllers.current.leftController.style.transform = "translate3d(".concat(Math.round(leftControlPosition), "px, 0, 0)");
      }
      if (controllers.current.rightController) {
        controllers.current.rightController.style.transform = "translate3d(".concat(Math.round(rightControlPosition), "px, 0, 0)");
      }
    };
    const requestId = window.requestAnimationFrame(() => {
      windowAnimation(homeWidth, drawWidth, awayWidth, leftControlPosition, rightControlPosition);
    });
    if (!homeBetButton || !drawBetButton || !awayBetButton) {
      window.cancelAnimationFrame(requestId);
    }
  }, [getButtonSizes, getControllerPositions]);
  const updateLabels = useCallback(() => {
    const roundedHomePercent = Math.round(newHomePercentage.current);
    const roundedAwayPercent = Math.round(newAwayPercentage.current);
    const roundedDrawPercent = 100 - (roundedHomePercent + roundedAwayPercent);
    const labels = [];
    labels[Index.Home] = selections[Index.Home] ? "".concat(roundedHomePercent, "%") : outcomeLabels[Index.Home].text;
    labels[Index.Draw] = selections[Index.Draw] ? "".concat(roundedDrawPercent, "%") : outcomeLabels[Index.Draw].text;
    labels[Index.Away] = selections[Index.Away] ? "".concat(roundedAwayPercent, "%") : outcomeLabels[Index.Away].text;
    labels.forEach((label, index) => {
      const labelEl = betButtons.current[index].querySelector('.btn-bet-label');
      if (labelEl) {
        labelEl.textContent = label;
      } else {
        betButtons.current[index].textContent = label;
      }
    });
  }, [outcomeLabels, selections]);
  const maxUncontrolledPercentage = 100 - (numSelectedButtons - 1) * MIN_PERCENTAGE;
  const calculateNewPercentages = useCallback((moveDiff, controlledIndex) => {
    let maxControlledPercentage = 100;
    if (allButtonsSelected) {
      const uncontrolledPercentaged = controlledIndex === Index.Home ? awayPercentage : homePercentage;
      maxControlledPercentage -= uncontrolledPercentaged + MIN_PERCENTAGE; 
    } else {
      maxControlledPercentage -= (numSelectedButtons - 1) * MIN_PERCENTAGE;
    }
    const totalAvailableWidthFraction = getTotalAvailableWidthFraction();
    if (controlledIndex === Index.Home) {
      newHomePercentage.current = selections[Index.Home] ? clampPercentages(homePercentage + moveDiff / totalAvailableWidthFraction, maxControlledPercentage) : 0;
      if (allButtonsSelected) {
        newAwayPercentage.current = awayPercentage;
      } else if (selections[Index.Away]) {
        newAwayPercentage.current = clampPercentages(awayPercentage - moveDiff / totalAvailableWidthFraction, maxUncontrolledPercentage);
      } else {
        newAwayPercentage.current = 0;
      }
    } else if (controlledIndex === Index.Away) {
      newAwayPercentage.current = selections[Index.Away] ? clampPercentages(awayPercentage - moveDiff / totalAvailableWidthFraction, maxControlledPercentage) : 0;
      if (allButtonsSelected) {
        newHomePercentage.current = homePercentage;
      } else if (selections[Index.Home]) {
        newHomePercentage.current = clampPercentages(homePercentage + moveDiff / totalAvailableWidthFraction, maxUncontrolledPercentage);
      } else {
        newHomePercentage.current = 0;
      }
    }
    newDrawPercentage.current = 100 - (newHomePercentage.current + newAwayPercentage.current);
    roundOfAThird();
  }, [allButtonsSelected, awayPercentage, homePercentage, numSelectedButtons, roundOfAThird, selections, getTotalAvailableWidthFraction, maxUncontrolledPercentage]);
  const handleBetButtonClick = useCallback(index => {
    dispatch(toggleAlternative({
      boardIndex: board,
      couponId,
      event,
      outcome: index,
      systemType
    }));
  }, [board, couponId, dispatch, event, systemType]);
  useEffect(() => {
    updateLabels();
  }, [updateLabels]);
  useEffect(() => {
    const el = reduceContainer.current;
    let resizeObserver;
    if (el) {
      resizeObserver = new ResizeObserver(_ref3 => {
        let _ref4 = _slicedToArray(_ref3, 1),
          entry = _ref4[0];
        reduceContainerWidth.current = entry.contentRect.width;
        updateInterface();
      });
      resizeObserver.observe(el);
    }
    updateInterface();
    return () => {
      if (resizeObserver) {
        resizeObserver.unobserve(el);
      }
    };
  }, [updateInterface]);
  useEffect(() => {
    const onControlMoveEvent = position => {
      const moveDiff = position - originalPosition;
      const controlledIndex = selectedControl === SelectedControl.Left ? Index.Home : Index.Away;
      calculateNewPercentages(moveDiff, controlledIndex);
      updateInterface();
      updateLabels();
    };
    const onMouseMoveEvent = e => {
      onControlMoveEvent(e.pageX);
    };
    const onTouchMoveEvent = e => {
      onControlMoveEvent(e.touches[0].clientX);
    };
    const removeAllListeners = () => {
      window.removeEventListener('mousemove', onMouseMoveEvent);
      window.removeEventListener('touchmove', onTouchMoveEvent);
    };
    if (selectedControl === SelectedControl.None) {
      removeAllListeners();
    } else {
      window.addEventListener('mousemove', onMouseMoveEvent);
      window.addEventListener('touchmove', onTouchMoveEvent);
    }
    return () => {
      removeAllListeners();
    };
  }, [selectedControl, calculateNewPercentages, originalPosition, updateInterface, updateLabels]);
  useEffect(() => {
    const onControlUpEvent = () => {
      dispatch(setSignDistribution({
        couponId,
        board,
        event,
        distributions: [newHomePercentage.current, newDrawPercentage.current, newAwayPercentage.current]
      }));
      setSelectedControl(SelectedControl.None);
      setOriginalPosition(undefined);
    };
    const onMouseUpEvent = () => {
      onControlUpEvent();
    };
    const onTouchEndEvent = () => {
      onControlUpEvent();
    };
    const removeAllListeners = () => {
      window.removeEventListener('mouseup', onMouseUpEvent);
      window.removeEventListener('touchend', onTouchEndEvent);
    };
    if (selectedControl === SelectedControl.None) {
      removeAllListeners();
    } else {
      window.addEventListener('mouseup', onMouseUpEvent);
      window.addEventListener('touchend', onTouchEndEvent);
    }
    return () => {
      removeAllListeners();
    };
  }, [board, couponId, dispatch, event, selectedControl]);
  const onControlDownEvent = (controller, position) => {
    setOriginalPosition(position);
    setSelectedControl(controller);
  };
  const onMouseDownEvent = (e, controller) => {
    e.preventDefault();
    onControlDownEvent(controller, e.pageX);
  };
  const onTouchStartEvent = (e, controller) => {
    onControlDownEvent(controller, e.touches[0].clientX); 
  };
  const handleKeyDown = (e, controllerRef, controller) => {
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      const rect = controllerRef.getBoundingClientRect();
      const startPosition = rect.left + window.scrollX + rect.width / 2;
      onControlDownEvent(controller, startPosition);
      const moveDiff = e.key === 'ArrowLeft' ? -getTotalAvailableWidthFraction() : getTotalAvailableWidthFraction();
      const controlledIndex = controller === SelectedControl.Left ? Index.Home : Index.Away;
      calculateNewPercentages(moveDiff, controlledIndex);
      updateInterface();
      updateLabels();
      dispatch(setSignDistribution({
        couponId,
        board,
        event,
        distributions: [newHomePercentage.current, newDrawPercentage.current, newAwayPercentage.current]
      }));
      setSelectedControl(SelectedControl.None);
      setOriginalPosition(undefined);
    }
  };
  const getAriaLabelForController = controller => {
    if (controller === SelectedControl.Left) {
      if (selections[1]) {
        return 'Justera andel för Utfall Ett, Hemmaseger respektive Utfall Kryss, Oavgjort';
      }
      return 'Justera andel för Utfall Ett, Hemmaseger respektive Utfall Två, Bortaseger';
    }
    if (controller === SelectedControl.Right) {
      if (selections[1]) {
        return 'Justera andel för Utfall Kryss, Oavgjort respektive Utfall Två, Bortaseger';
      }
      return 'Justera andel för Utfall Ett, Hemmaseger respektive Utfall Två, Bortaseger';
    }
  };
  const getAriaValueTextForController = controller => {
    if (controller === SelectedControl.Left) {
      if (selections[1]) {
        return "Hemmaseger ".concat(Math.round(homePercentage), "%, Oavgjort ").concat(Math.round(drawPercentage), "%");
      }
      return "Hemmaseger ".concat(Math.round(homePercentage), "%, Bortaseger ").concat(Math.round(awayPercentage), "%");
    }
    if (controller === SelectedControl.Right) {
      if (selections[1]) {
        return "Oavgjort ".concat(Math.round(drawPercentage), "%, Bortaseger ").concat(Math.round(awayPercentage), "%");
      }
      return "Hemmaseger ".concat(Math.round(homePercentage), "%, Bortaseger ").concat(Math.round(awayPercentage), "%");
    }
  };
  const getAriaLabelForOutcome = index => {
    let ariaLabel = outcomeLabels[index].ariaLabel;
    if (index === Index.Home) {
      ariaLabel += ", ".concat(Math.round(homePercentage), "%");
    } else if (index === Index.Draw) {
      ariaLabel += ", ".concat(Math.round(drawPercentage), "%");
    } else if (index === Index.Away) {
      ariaLabel += ", ".concat(Math.round(awayPercentage), "%");
    }
    return ariaLabel;
  };
  return React.createElement("div", {
    "aria-label": "V\xE4lj utfall och justera deras andel med reglage f\xF6r 1, Kryss och 2",
    className: "reduce-free-container",
    onClick: preventDefault,
    onMouseDown: preventDefault,
    onMouseUp: preventDefault,
    ref: reduceContainer,
    role: "group"
  }, React.createElement("div", {
    className: "reduce-free-outcome-container"
  }, React.createElement("div", {
    className: "reduce-free-outcomes"
  }, selections.map((selection, index) => {
    const key = "".concat(board, "_").concat(event, "_").concat(index);
    const buttonClassNames = ['coupon-button-bet', 'reduce-free-btn-bet'];
    if (index === Index.Home && isControlLeftVisible || index === Index.Away && isControlRightVisible) {
      buttonClassNames.push('coupon-button-bet-selected-margin');
    }
    return React.createElement(React.Fragment, {
      key: key
    }, isControlRightVisible && index === Index.Away && React.createElement("button", {
      "aria-label": getAriaLabelForController(SelectedControl.Right),
      "aria-valuemax": 100 - MIN_PERCENTAGE,
      "aria-valuemin": MIN_PERCENTAGE,
      "aria-valuenow": Math.round(awayPercentage),
      "aria-valuetext": getAriaValueTextForController(SelectedControl.Right),
      className: "reduce-free-outcome-slider-button",
      onContextMenu: preventDefault 
      ,
      onKeyDown: e => {
        handleKeyDown(e, controllers.current.rightController, SelectedControl.Right);
      },
      onMouseDown: e => {
        onMouseDownEvent(e, SelectedControl.Right);
      },
      onTouchStart: e => {
        onTouchStartEvent(e, SelectedControl.Right);
      },
      ref: node => {
        controllers.current.rightController = node;
      },
      role: "slider",
      type: "button"
    }, React.createElement("div", {
      className: "reduce-free-outcome-slider-content"
    }, React.createElement(ReactIcon, {
      color: "fc-red",
      icon: "caret-left",
      size: "100"
    }), React.createElement(ReactIcon, {
      color: "fc-red",
      icon: "caret-right",
      size: "100"
    }))), React.createElement(ReduceButtonBet, {
      ariaLabel: getAriaLabelForOutcome(index),
      branding: branding,
      className: buttonClassNames.join(' '),
      dataTestId: key,
      index: index,
      isDisabled: isDisabled,
      label: outcomeLabels[index].text,
      onClick: handleBetButtonClick,
      refFunc: node => {
        betButtons.current[index] = node;
      },
      selected: selection,
      type: "button"
    }), isControlLeftVisible && index === Index.Home && React.createElement("button", {
      "aria-label": getAriaLabelForController(SelectedControl.Left),
      "aria-valuemax": 100 - MIN_PERCENTAGE,
      "aria-valuemin": MIN_PERCENTAGE,
      "aria-valuenow": Math.round(homePercentage),
      "aria-valuetext": getAriaValueTextForController(SelectedControl.Left),
      className: "reduce-free-outcome-slider-button",
      onContextMenu: preventDefault 
      ,
      onKeyDown: e => {
        handleKeyDown(e, controllers.current.leftController, SelectedControl.Left);
      },
      onMouseDown: e => {
        onMouseDownEvent(e, SelectedControl.Left);
      },
      onTouchStart: e => {
        onTouchStartEvent(e, SelectedControl.Left);
      },
      ref: node => {
        controllers.current.leftController = node;
      },
      role: "slider",
      type: "button"
    }, React.createElement("div", {
      className: "reduce-free-outcome-slider-content"
    }, React.createElement(ReactIcon, {
      color: "fc-red",
      icon: "caret-left",
      size: "100"
    }), React.createElement(ReactIcon, {
      color: "fc-red",
      icon: "caret-right",
      size: "100"
    }))));
  }))));
};
setGlobal('svs.components.tipsen.coupon.ReduceFreeBets', ReduceFreeBets);

 })(window);